import { IComponent } from "@faire/web-api/indigofair/data/IComponent";
import { Row } from "@faire/web/slate/Layout/Row";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";

import { FilterInfoSticky } from "@faire/retailer/components/Filters/FilterInfoSticky";
import { getSDUIFilterName } from "@faire/retailer/components/SDUI/__internal__/Filters/getSDUIFilterName";
import {
  ComponentLoggingEventParams,
  SectionLoggingEventParams,
} from "@faire/retailer/components/SDUI/__internal__/types";
import { subtitleStyle } from "@faire/retailer/components/SDUI/ComponentRenderers/FilterBar/__internal__/styles.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";

export const SDUIFilterRowRenderer = ({
  isFilterLoading,
  sectionLoggingParams,
  component,
}: {
  component: IComponent;
  formattedTotalResults?: string;
  sectionLoggingParams: SectionLoggingEventParams;
  isFilterLoading: boolean;
}) => {
  const filterBarComponent = component.filter_bar_component;
  const loggingEventParams: ComponentLoggingEventParams =
    ComponentLoggingEventParams.build({
      ...sectionLoggingParams,
      ...component.logging_data,
      component_id: component.id,
    });

  if (filterBarComponent === undefined) {
    return null;
  }

  return (
    <>
      {filterBarComponent.title ? (
        <Row
          align="center"
          style={
            filterBarComponent.subtitle
              ? undefined
              : { paddingBottom: getSpacing("1x") }
          }
        >
          <SDUITypographyRenderer
            textElement={filterBarComponent.title}
            loggingData={loggingEventParams}
          />
        </Row>
      ) : null}
      {filterBarComponent.subtitle ? (
        <SDUITypographyRenderer
          textElement={filterBarComponent.subtitle}
          loggingData={loggingEventParams}
          className={subtitleStyle}
        />
      ) : null}
      <FilterInfoSticky
        name={getSDUIFilterName(loggingEventParams?.view_display_page)}
        isLoading={isFilterLoading}
        shouldShowSort
        shouldEnableScrollToProducts
      />
    </>
  );
};
